import {
  SMS_DONATION_LOADING,
  SMS_DONATION_SUCCESS,
  SMS_DONATION_FAILURE,
} from "redux/types";

const initialState = {
  smsDonationLoading: false,
  smsDonationData: null,
  errors: null,
};

export const smsDonationReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SMS_DONATION_LOADING:
      return { ...state, smsDonationLoading: action.payload };
    case SMS_DONATION_SUCCESS:
      return { ...state, smsDonationData: action.payload };
    case SMS_DONATION_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
